import xhrCaller from "./xhr-caller";


export const xhrTenantGetTenantAll = async (token, pi, pr) => {
	
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTenantAll?pi=${pi??0}&pr=${pr??200}`});
	return result;
}

export const xhrTenantGetTechniciansByTenantIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTechniciansByTenantIds`, data, method: 'get', cache: true});	
	return result;
};

export const xhrTenantGetDoctorsByTenantIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDoctorsByTenantIds`, data, method: 'get', cache: true});	
	return result;
};

export const xhrTenantGetTypistsByTenantIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTypistsByTenantIds`, data, method: 'get', cache: true});	
	return result;
};

export const xhrTenantGetTechniciansByInstitutionIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTechniciansByInstitutionIds`, data, method: 'get', cache: true});	
	return result;
};

export const xhrTenantGetDoctorsByInstitutionIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDoctorsByInstitutionIds`, data, method: 'get', cache: true});	
	return result;
};

export const xhrTenantGetTypistsByInstitutionIds = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTypistsByInstitutionIds`, data, method: 'get', cache: true});	
	return result;
}

export const xhrTenantDeleteTenant = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/DeleteTenant?id=${id}`, method: "delete"});
	return result;
}

export const xhrTenantGetTenantById = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTenantById?id=${id}`});
	return result;
}

export const xhrTenantAddUpdTenant = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/AddUpdTenant`, method: "post"});
	return result;
}

export const xhrTenantGetDepartmentAll = async (token, page, perPage) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDepartmentAll?pi=${page??0}&pr=${perPage??200}`});
	return result;
}

export const xhrTenantDeleteDepartment = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/DeleteDepartment?id=${id}`, method: "delete"});
	return result;
}

export const xhrTenantGetDepartmentById = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDepartmentById?id=${id}`});
	return result;
}

export const xhrTenantAddUpdDepartment = async (token, data, ) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/AddUpdDepartment`, method: "post"});
	return result;
}

export const xhrTenantGetTechnicalAreaAll = async (token, page, perPage) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTechnicalAreaAll?pi=${page??0}&pr=${perPage??200}`});
	return result;
}

export const xhrTenantDeleteTechnicalArea = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/TechnicaDeletelArea?id=${id}`, method: "delete"});
	return result;
}

export const xhrTenantGetTechnicalAreaById = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTechnicalAreaById?id=${id}`});
	return result;
}

export const xhrTenantAddUpdTechnicalArea = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/AddUpdTechnicalArea`, method: "post"});
	return result;
}

export const xhrTenantGetAgreementAll = async (token, page, perPage) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetAgreementAll?pi=${page??0}&pr=${perPage??200}`});
	return result;
}

export const xhrTenantGetAgreementById = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetAgreementById?id=${id}`});
	return result;
}

export const xhrTenantAddUpdAgreement = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/AddUpdAgreement`, method: "post"});
	return result;
}

export const xhrTenantGetReferringEntityById = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetReferringEntityById?id=${id}`});
	return result;
}

export const xhrTenantGetReferringEntityAll = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/GetReferringEntityAll`});
	return result;
}

export const xhrTenantAddUpdReferringEntity = async (token, data) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', data, action: `Tenant/AddUpdReferringEntity`, method:"post"});
	return result;
}

export const xhrTenantGetDepartmentsByTenantId = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDepartmentsByTenantId?id=${id}`});
	return result;
}

export const xhrTenantGetTechnicalAreasByTenantId = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetTechnicalAreasByTenantId?id=${id}`});
	return result;
}

export const xhrTenantGetAgreementsByTenantId = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetAgreementsByTenantId?id=${id}`});
	return result;
}

export const xhrTenantDeleteReferringEntity = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/DeleteReferringEntity?id=${id}`, method: "delete"});
	return result;
}

export const xhrTenantDeleteAgreement = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/DeleteAgreement?id=${id}`, method: "delete"});
	return result;
}

export const xhrTenantGetUserProfilesByTenantId = async (token, id) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetUserProfilesByTenantId?id=${id}`});
	return result;
}

export const xhrTenantGetDoctorAll = async (token) => {
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Tenant/GetDoctorAll`});
	return result;
}
